import { useMediaQuery } from "react-responsive";

import { DesktopHeader } from "components/page-header/desktop-header";
import { MobileHeader } from "components/page-header/mobile-header";
import { screenSizes } from "consts";

type PageHeaderProps = {
  hideNavigation?: boolean;
};

export const PageHeader = ({ hideNavigation }: PageHeaderProps) => {
  const isMobile = useMediaQuery({
    maxWidth: screenSizes.laptop,
  });

  return isMobile ? (
    <MobileHeader />
  ) : (
    <DesktopHeader hideNavigation={hideNavigation} />
  );
};
